import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { Contact } from "../../types/Contact";

export const getMyContact = () => {
  const { fetchWithAuth } = useApi();
  return useQuery(["contact"], (): Promise<Contact> => {
    return fetchWithAuth<Contact>("getMyContact");
  });
};
